'use client'
import { useEffect, useState } from 'react'

export function useLoader (): boolean {
  const [isLoaderRemoved, setIsLoaderRemoved] = useState(false)

  useEffect(() => {
    // Create a timeout and store its ID
    const timeoutId = setTimeout(() => {
      setIsLoaderRemoved(true)
    }, 2500)

    // Cleanup the timeout if the component unmounts
    return () => {
      clearTimeout(timeoutId)
    }
  }, [])

  return isLoaderRemoved
}
